import React, { useRef, useState, useEffect } from 'react'
import { Link, useLocation, redirect } from 'react-router-dom'
import menus from '../../pages/menu'
import DarkMode from './DarkMode'
import logoheader from '../../assets/images/logo/logo.png'
import logoheader2x from '../../assets/images/logo/logo.png'
import logodark from '../../assets/images/logo/logo.png'
import logodark2x from '../../assets/images/logo/logo.png'
import imgsun from '../../assets/images/icon/sun.png'
import useAuthStore from '../../stores/authStore'
import avt from '../../assets/images/avatar/ava.jpg'

const Header = () => {
    const { pathname } = useLocation()
    const { token, logout, loadUserFromLocalStorage } = useAuthStore()

    useEffect(() => {
        const loadToken = async () => {
            await loadUserFromLocalStorage()
        }
        loadToken()
    }, [loadUserFromLocalStorage])

    const headerRef = useRef(null)
    // useEffect(() => {
    //     window.addEventListener('scroll', isSticky)
    //     return () => {
    //         window.removeEventListener('scroll', isSticky)
    //     }
    // })
    // const isSticky = (e) => {
    //     const header = document.querySelector('.js-header')
    //     const scrollTop = window.scrollY
    //     scrollTop >= 300 ? header.classList.add('is-fixed') : header.classList.remove('is-fixed')
    //     scrollTop >= 400 ? header.classList.add('is-small') : header.classList.remove('is-small')
    // }

    const menuLeft = useRef(null)
    const btnToggle = useRef(null)
    const btnSearch = useRef(null)
    const btnUser = useRef(null)

    const menuToggle = () => {
        menuLeft.current.classList.toggle('active')
        btnToggle.current.classList.toggle('active')
    }

    const searchBtn = () => {
        btnSearch.current.classList.toggle('active')
    }

    const userBtn = () => {
        btnUser.current.classList.toggle('active')
    }

    const [activeIndex, setActiveIndex] = useState(null)
    const handleOnClick = (index) => {
        setActiveIndex(index)
    }

    const handleLogout = async (e) => {
        e.preventDefault()
        await logout()
        redirect('/login')
    }

    const role = localStorage.getItem('role')
    const user_id = localStorage.getItem('user_id')
    const email = localStorage.getItem('email')

    return (
        <header id="header_main" className="header_1 js-header js-header is-fixed is-small" ref={headerRef}>
            <div className="themesflat-container">
                <div className="row">
                    <div className="col-md-12">
                        <div id="site-header-inner">
                            <div className="wrap-box flex">
                                <div id="site-logo" className="clearfix">
                                    <div id="site-logo-inner">
                                        <Link to="/" rel="home" className="main-logo">
                                            <img
                                                className="logo-dark"
                                                id="logo_header"
                                                src={logodark}
                                                srcSet={`${logodark2x}`}
                                                alt="nft-gaming"
                                            />
                                            <img
                                                className="logo-light"
                                                id="logo_header"
                                                src={logoheader}
                                                srcSet={`${logoheader2x}`}
                                                alt="nft-gaming"
                                            />
                                        </Link>
                                    </div>
                                </div>
                                <div className="mobile-button" ref={btnToggle} onClick={menuToggle}>
                                    <span></span>
                                </div>
                                <nav id="main-nav" className="main-nav" ref={menuLeft}>
                                    <ul id="menu-primary-menu" className="menu">
                                        {menus.map((data, index) => (
                                            <li
                                                key={index}
                                                onClick={() => handleOnClick(index)}
                                                className={`menu-item ${data.namesub ? 'menu-item-has-children' : ''} ${activeIndex === index ? 'active' : ''} `}
                                            >
                                                <Link to={data.links}>{data.name}</Link>
                                                {data.namesub && (
                                                    <ul className="sub-menu">
                                                        {data.namesub.map((submenu) => (
                                                            <li
                                                                key={submenu.id}
                                                                className={
                                                                    pathname === submenu.links
                                                                        ? 'menu-item current-item'
                                                                        : 'menu-item'
                                                                }
                                                            >
                                                                <Link to={submenu.links}>{submenu.sub}</Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                                <div className="flat-search-btn flex">
                                    {token && (
                                        <div className="header-search flat-show-search" id="s1">
                                            <Link to="#" className="show-search header-search-trigger">
                                                <i className="fa fa-bell"></i>
                                            </Link>
                                        </div>
                                    )}

                                    <div className="sc-btn-top mg-r-12 " id="site-header">
                                        <Link to="/cart" className="sc-button style bag fl-button pri-3 no-bg">
                                            <span></span>
                                        </Link>
                                    </div>

                                    {token && (
                                        <div className="" id="header_admin">
                                            <div className="header_avatar" onClick={userBtn}>
                                                <img className="avatar" src={avt} alt="avatar" />
                                                <div className="avatar_popup mt-20" ref={btnUser}>
                                                    <div className="d-flex align-items-center copy-text justify-content-between">
                                                        <p style={{ color: '#000', fontWeight: 'bold' }}>{email}</p>
                                                    </div>
                                                    <div className="links">
                                                        {/*<Link to="#">
                                                        <i className="fab fa-accusoft"></i> <span> My items</span>
                                                    </Link>*/}
                                                        <a className="mt-10" href="/edit-profile">
                                                            <i className="fas fa-pencil-alt"></i> <span>Hồ sơ</span>
                                                        </a>
                                                        <a className="mt-10" href="/transaction-history">
                                                            <i className="fas fa-exchange"></i> <span>Giao dịch</span>
                                                        </a>
                                                        <a className="mt-10" href="" onClick={handleLogout} id="logout">
                                                            <i className="fas fa-sign-out"></i> <span>Đăng xuất</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {!token && (
                                        <div className="sc-btn-top mg-r-12" id="site-header">
                                            <Link
                                                to="/login"
                                                className="sc-button header-slider style style-1 wallet fl-button pri-1"
                                            >
                                                <span>Đăng nhập</span>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
